import { ECreditApplicationStatus, EDecision, EDocumentType, EProgressionStatus } from '@if/core/types'
import { green, grey, orange, red } from '@mui/material/colors'
import { RequiredDocument } from '@src/types/RequiredDocument'

export const getPrequalColor = (creditApplicationStatus: ECreditApplicationStatus, prequalDecision: EDecision) => {
  if (creditApplicationStatus === ECreditApplicationStatus.Draft) {
    return grey[500]
  }
  if (prequalDecision === EDecision.Refused) {
    return red[500]
  }
  if (prequalDecision === EDecision.Approved) {
    return green[500]
  }
  return orange[500]
}

export const getCreditColor = (prequalDecision: EDecision, hardHitDecision: EDecision) => {
  if (hardHitDecision === EDecision.Refused) {
    return red[500]
  }
  if (hardHitDecision === EDecision.Approved) {
    return green[500]
  }
  if (
    prequalDecision === EDecision.Approved &&
    ((hardHitDecision as string) === '' || hardHitDecision === EDecision.ManualRevision)
  ) {
    return orange[500]
  }

  return grey[500]
}

export const getIncomeVerificationColor = (
  prequalDecision: EDecision,
  hardHitDecision: EDecision,
  isIncomeConfirmed: boolean,
) => {
  if (isIncomeConfirmed) {
    return green[500]
  }
  if (prequalDecision === EDecision.Approved && hardHitDecision === EDecision.Approved) {
    return orange[500]
  }

  return grey[500]
}

export const getContractColor = (
  hardHitDecision: EDecision,
  isIncomeConfirmed: boolean,
  isContractSignatureMethodSelected: boolean,
  missingRequiredDocuments: RequiredDocument[],
) => {
  if (hardHitDecision === EDecision.Approved && isIncomeConfirmed === true) {
    const hasCvtSigned = !missingRequiredDocuments.some((doc) => doc.typeId === EDocumentType.SignedCVT)
    if (isContractSignatureMethodSelected === true && hasCvtSigned === true) {
      return green[500]
    }
    return orange[500]
  }

  return grey[500]
}

export const getFundingColor = (
  status: EProgressionStatus,
  hardHitDecision: EDecision,
  isIncomeConfirmed: boolean,
  isContractSignatureMethodSelected: boolean,
) => {
  if (status === EProgressionStatus.PaymentPending || status === EProgressionStatus.Booked) {
    return green[500]
  }
  if (
    isContractSignatureMethodSelected === true &&
    hardHitDecision === EDecision.Approved &&
    isIncomeConfirmed === true
  ) {
    return orange[500]
  }

  return grey[500]
}
